import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./app";
import "./app.css";

const url = new URL(window.location.href);
if (url.hash.startsWith("#token=")) {
  const token = decodeURIComponent(url.hash.slice("#token=".length).split("&")[0] ?? "");
  if (token) sessionStorage.setItem("glambyzra_oauth_token", token);
  history.replaceState(null, "", "/dashboard");
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
});

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);